import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=c2d07d1c&scoped=true&"
import script from "./courseDetail.vue?vue&type=script&lang=js&"
export * from "./courseDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=c2d07d1c&scoped=true&lang=css&"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=c2d07d1c&scoped=true&lang=css&"
import style2 from "./courseDetail.vue?vue&type=style&index=2&id=c2d07d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d07d1c",
  null
  
)

export default component.exports